import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Paper,
  Button,
  Chip,
  // Tooltip,
  Collapse,
  Link,
} from '@mui/material';

function TdcProductsCard(props) {
  const {
    logo,
    title,
    upperText,
    lowerText,
    // buttonText,
    chipText,
    chipColor,
    deliveryWindow,
    pricing,
    helpDocumentation,
    collapseOption,
  } = props;

  const [open, setOpen] = useState(false);

  const handleExpandClick = () => {
    setOpen(!open);
  };

  return (
    <Box>
      <Paper variant="outlined" sx={{ backgroundColor: '#fff', margin: '10px', padding: '20px' }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          {logo
            && <img src={logo} alt="Product logo" style={{ height: '50px' }} />}
          <h3>{title}</h3>
          {chipText.map((item, i) => (
            <Chip
              label={item}
              sx={{
                margin: '5px', color: 'white', backgroundColor: chipColor[i], fontWeight: '800',
              }}
            />
          ))}
          {/* commented out for now until deliveries feature is ready */}
          {/* {buttonText
            && (
              <Tooltip title="Coming soon" placement="right-start">
                <span style={{ marginLeft: 'auto' }}>
                <Button
                  disabled sx={{ marginLeft: 'auto', width: '200px' }}
                  variant="contained">
                  {buttonText}
                </Button>
                </span>
              </Tooltip>
            )} */}
        </Box>
        <h4>What is it?</h4>
        <p>{upperText}</p>
        <h4>Who is it best for?</h4>
        <p>{lowerText}</p>
        {collapseOption
          && (
            <Button variant="outlined" sx={{ margin: 'auto', display: 'flex', justifyContent: 'center' }} onClick={handleExpandClick}>
              {open ? 'Show less' : 'Show more'}
            </Button>
          )}
        <Collapse in={open} timeout="auto" unmountOnExit>
          {deliveryWindow
            && (
              <>
                <h4>Delivery Window</h4>
                <p>{deliveryWindow}</p>
              </>
            )}
          {pricing
            && (
              <>
                <h4>Pricing</h4>
                <p>{pricing}</p>
              </>
            )}
          {helpDocumentation.length > 0
            && <h4>Help Documentation</h4>}
          <ul className="productHelpDocsList">
            {helpDocumentation.map((item, i) => (
              <li>
                <Link
                  target="_blank"
                  rel="noreferrer"
                  href={helpDocumentation[i].link}
                >
                  {helpDocumentation[i].text}
                </Link>
              </li>
            ))}
          </ul>
        </Collapse>
      </Paper>
    </Box>
  );
}

export default TdcProductsCard;

TdcProductsCard.propTypes = {
  logo: PropTypes.oneOfType([
    PropTypes.string,
  ]),
  title: PropTypes.string.isRequired,
  upperText: PropTypes.string.isRequired,
  lowerText: PropTypes.string.isRequired,
  // buttonText: PropTypes.string,
  chipText: PropTypes.arrayOf(PropTypes.string),
  chipColor: PropTypes.arrayOf(PropTypes.string),
  deliveryWindow: PropTypes.string,
  pricing: PropTypes.string,
  helpDocumentation: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string,
    link: PropTypes.string,
  })),
  collapseOption: PropTypes.bool,
};
